import { render, staticRenderFns } from "./NavigatorDrawer.vue?vue&type=template&id=fbab7ea6&"
import script from "./NavigatorDrawer.vue?vue&type=script&lang=ts&"
export * from "./NavigatorDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports